import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorInstitutes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M6.75 5.5a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5h-1.5v4.256l5.547 7.627c1.322 1.817.023 4.367-2.224 4.367H4.928c-2.248 0-3.546-2.55-2.224-4.367L8.25 9.756V5.5h-1.5ZM9.2 11l-5.283 7.265a1.25 1.25 0 0 0 1.01 1.985h14.146a1.25 1.25 0 0 0 1.01-1.985L14.8 11H9.2Zm5.05-1.5V5.75h-4.5V9.5h4.5Z"
    />
    <path
      fill="#F7A600"
      d="M10.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm4.5 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default SvgTwoColorInstitutes;
